import { useNavigate } from "react-router-dom";
import { List, ListItem } from "@mui/material";
import { colors as c } from "../common/colors";

interface Props {
  tags: any[];
}

export default function PostTags({ tags }: Props) {
  const navigate = useNavigate();

  const handleClickTag = (tag: string) => {
    navigate("/search", {state: { termProps: tag }})
  }

  return (
    <List sx={styles.tagsContainer}>
      {tags.map((tag: any) => (
        <ListItem
          key={tag.tag}
          sx={styles.tag}
          onClick={() => handleClickTag(`#${tag.tag}`)}
        >
          #{tag.tag}
        </ListItem>
      ))}
    </List>
  );
}

const styles = {
  tagsContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-start",
    gap: 1,
    flexWrap: "wrap"
  },

  tag: {
    width: "auto",
    maxWidth: "100%",
    padding: 0,
    color: c.farm_blue200,
    fontSize: "16px",
    wordBreak: "break-all"
  },
}